/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantFourYearOld } from './InfantFourYearOld';
import {
    InfantFourYearOldFromJSON,
    InfantFourYearOldFromJSONTyped,
    InfantFourYearOldToJSON,
} from './InfantFourYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantFourYearOldPagination
 */
export interface InfantFourYearOldPagination {
    /**
     * 
     * @type {Array<InfantFourYearOld>}
     * @memberof InfantFourYearOldPagination
     */
    data?: Array<InfantFourYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantFourYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantFourYearOldPagination interface.
 */
export function instanceOfInfantFourYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantFourYearOldPaginationFromJSON(json: any): InfantFourYearOldPagination {
    return InfantFourYearOldPaginationFromJSONTyped(json, false);
}

export function InfantFourYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantFourYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantFourYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantFourYearOldPaginationToJSON(value?: InfantFourYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantFourYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

